
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class ErrorGeneral extends Vue {
  @Prop() title!: string;
  @Prop() description!: string;
  @Prop({default: true}) backToHome!: boolean;
}
